export default {
    methods: {
        buildExportFieldsFromColumns(columns = []) {
            const fields = {};

            columns.forEach((column) => {
                const label = column.label;
                const field = column.field;

                if (label && field && label !== 'Action' && field !== 'action') {
                    fields[label] = field;
                }
            });

            return fields;
        },

        showExportFlash(type, message) {
            this.$page.props.flash.success = null;
            this.$page.props.flash.error = null;

            this.$nextTick(() => {
                if (type === 'success') {
                    this.$page.props.flash.success = message;
                    return;
                }

                this.$page.props.flash.error = message;
            });
        },

        async exportTableData(routeName, routeParams = {}, fileType = 'csv', extraParams = {}) {
            try {
                const response = await axios.get(route(routeName, routeParams), {
                    params: {
                        api: true,
                        no_pagination: true,
                        file_type: fileType,
                        ...this.filters,
                        ...extraParams,
                    },
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                const payload = response.data;

                if (payload?.message) {
                    this.showExportFlash('success', payload.message);

                    return;
                }

                const rows = Array.isArray(payload) ? payload : payload?.data ?? [];
                this.exportRows = rows;

                this.$nextTick(() => {
                    const exporter = this.$refs[`exporter-${fileType}`];

                    if (exporter) {
                        exporter.generate();
                    }
                });
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors ?? {};
                }

                console.error(error);
            }
        },

        async exportReportData(routeName, routeParams = {}, params = {}, fileType = 'csv') {
            try {
                const response = await axios.get(route(routeName, routeParams), {
                    params: {
                        api: true,
                        no_pagination: true,
                        file_type: fileType,
                        ...params,
                    },
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                const payload = response.data;

                if (payload?.message) {
                    this.showExportFlash('success', payload.message);

                    return;
                }

                this.exportRows = Array.isArray(payload) ? payload : payload?.rows ?? [];

                this.$nextTick(() => {
                    const exporter = this.$refs[`exporter-${fileType}`];

                    if (exporter) {
                        exporter.generate();
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },

        async exportPostReportData(routeName, payload = {}, fileType = 'csv', refPrefix = '') {
            try {
                const response = await axios.post(route(routeName), {
                    ...payload,
                    unpaginated: true,
                    file_type: fileType,
                });

                const data = response.data;

                if (data?.message) {
                    this.showExportFlash('success', data.message);

                    return;
                }

                const rows = Array.isArray(data) ? data : data?.data ?? [];

                this.exportRows = rows.map((item) => {
                    Object.keys(item).forEach((key) => {
                        if (typeof item[key] === 'string') {
                            item[key] = item[key].replace(/\"/g, '');
                        }
                    });

                    return item;
                });

                this.$nextTick(() => {
                    const refKey = refPrefix ? `${refPrefix}-exporter-${fileType}` : `exporter-${fileType}`;
                    const exporter = this.$refs[refKey];

                    if (exporter) {
                        exporter.generate();
                    }
                });
            } catch (error) {
                console.error(error);
            }
        },
    },
};
